import { createFileRoute } from "@tanstack/react-router";
import { lazy } from "react";
const ResetPassword = lazy(() => import("@/pages/ResetPassword"));

export const Route = createFileRoute("/reset-password")({
  component: ResetPassword,
});
